import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";
import { buildCrudPermissions, permissionId } from "../../shared/featureFactories";

export const LedgerToolsFeature: FeatureMetadata = {
  id: "ledger-tools",
  moduleName: "feesFinance",
  navigation: {
    label: "Ledger Tools",
    path: "/ledger-tools",
    icon: AdjustmentsHorizontalIcon,
    order: 9,
  },
  route: {
    path: "/ledger-tools",
    element: lazy(() => import("./pages/AdminLedgerTools")),
  },
  permissions: buildCrudPermissions("FeeFinance", "Ledger", {
    view: permissionId("FeeFinance", "Ledger", "generate"),
    create: permissionId("FeeFinance", "Ledger", "generate"),
    edit: permissionId("FeeFinance", "Ledger", "generate"),
    delete: permissionId("FeeFinance", "Ledger", "generate"),
  }),
  readiness: "live",
};
